import gql from 'graphql-tag'

export const businessAccountPendingMembersQuery = gql`
    query businessAccountPendingMembersQuery(
        $filters: BusinessAccountPendingMembersFilterInput
        $offset: Int!
        $limit: Int!
    ) {
        businessAccountPendingMembers(
            filters: $filters
            offset: $offset
            limit: $limit
        ) {
            totalCount
            items {
                lastLoginDate
                salesforceContactUrl
                capabilities
                invite {
                    id
                    email
                    sentDate
                    status
                }
                user {
                    id
                    displayName
                    email
                }
            }
        }
    }
`
